module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yMgL2G/tc-custom/9781488060151.jpg?1701235130069",
      "alt": "This image is the cover for the book Prodigal Cowboy, Mercy Ranch"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prodigal Cowboy, Mercy Ranch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Can an unexpected reunion change his wandering ways?"), _c('br'), _c('br'), _c('b', [_vm._v("His last chance to make things right…")]), _c('br'), _c('br'), _c('b', [_vm._v("means reuniting the family he once lost.")]), _c('br'), _c('br'), _vm._v("Bull fighter Colt West gave up everything for the rodeo—including his sweetheart, Holly Carter. Now he’s come home to Hope, Oklahoma, with unexpected news: he and Holly are the guardians of the daughter they gave up for adoption eleven years ago. It’s a chance to be a family. But can Holly trust that her cowboy is finally here to stay?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brenda Minton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brenda Minton lives in the Ozarks. She's a wife, mom to three, foster mom to five and grandma to a princess.  Life is chaotic but she enjoys every minute of it with her family and a few too many dogs. When not writing she's drinking coffee on the patio, wrangling kids or escaping for an evening out  with her husband.  Visit her online at www.brendaminton.net")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0